import { baseUrl } from '@/config/env';
import request from '@/router/axios';

export const getAliyunPublicToken = () => {
    return request({
        url: `${baseUrl}/joins-oss/v1/aliyun/public/token?sessionName=JOINS_PUBLIC_IMAGE_TOKEN`,
        method: 'GET'
    })
}